var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"separator",class:_vm.paddingClass + ' ' + _vm.marginClass + ' ' + _vm.colClass},[(_vm.withHr)?_c('hr'):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }